import { createSelector } from 'reselect';
import * as AuthSelectors from './auth';
import { Role } from '@/constants';
export function glancerAnalyticsSelector({ glancerAnalytics }) {
    return glancerAnalytics;
}
export const glancerDashboardsSelector = createSelector(glancerAnalyticsSelector, ({ dashboards }) => dashboards);
export const glancerAccessSelector = createSelector(AuthSelectors.activeUserSelector, (activeUser) => !!activeUser && activeUser.allowedAccess.includes(Role.ANALYTICS));
export const glancerEmbedUrlSelector = createSelector(glancerAnalyticsSelector, ({ embedUrl }) => embedUrl);
